'use es6';

import { createStore, applyMiddleware, compose as reduxCompose } from 'redux';
import thunk from 'redux-thunk';
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import { asyncRequest, cachedRequest } from 'dashboard-lib/public/request/request-middleware';
import rootReducer from '../reducers';
import actionTypes from '../constants/actionTypes';
const {
  HISTORY_METHOD_CALLED
} = actionTypes;
const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || reduxCompose;
const routerMiddleware = history => () => next => action => {
  if (action.type === HISTORY_METHOD_CALLED) {
    const {
      payload: {
        method,
        args
      }
    } = action;
    history[method](...args);
  }
  return next(action);
};
const createStoreWithMiddleware = history => compose(applyMiddleware(asyncRequest, cachedRequest, thunk, NotificationMiddleware, routerMiddleware(history)))(createStore);
export default function configureStore(initialState, history) {
  return createStoreWithMiddleware(history)(rootReducer, initialState);
}